module.exports = __webpack_public_path__ + "img/mic.a72fdee8.svg";